import { LoadingContainer, Json, LegacyPage } from 'peach/components'
import {
  usePeachy,
  usePit,
  // useStatusFlagsGet
} from 'core/types'

const Home = () => {
  const {
    data: peachy,
    isLoading: loadingPeachy,
    error: peachyError,
  } = usePeachy({})

  const { data: pit, isLoading: loadingPit, error: pitError } = usePit({})

  // const {
  //   data: flags,
  //   isLoading: loadingFlags,
  //   error: flagsError
  // } = useStatusFlagsGet()

  return (
    <LoadingContainer
      error={peachyError || pitError}
      loading={loadingPeachy || loadingPit}
    >
      <LegacyPage>
        <Json.Table json={peachy} title='Peachy' />
        <Json.Table json={pit} title='Pit' />
        {/* <Json.Table json={flags} title='Flags' /> */}
      </LegacyPage>
    </LoadingContainer>
  )
}

export default Home
